import { Routes } from '@angular/router';
import { HomeComponent } from './home';
import { AboutComponent } from './about';
import { ExperiencesComponent } from './experiences';
import { TrainingComponent } from './training';
import { ClubComponent } from './club';
import { FleetComponent } from './fleet';
import { MembershipComponent } from './membership';
import { FeesComponent } from './fees';
import { ContactComponent } from './contact';
import { JoinComponent } from './join';
import { RenewComponent } from './renew';
import { BookComponent } from './book';
import { TosComponent } from './tos';
import { TncComponent } from './tnc';
import { NewsComponent } from './news';

import { NoContentComponent } from './no-content';

import { DataResolver } from './app.resolver';

export const ROUTES: Routes = [
  { path: '',      component: HomeComponent },
  { path: 'home',  component: HomeComponent, data: { state: 'home' }  },
  { path: 'about', component: AboutComponent, data: { state: 'about' }  },
  { path: 'experiences', component: ExperiencesComponent, data: { state: 'experiences' }  },
  { path: 'experiences/:part', component: ExperiencesComponent, data: { state: 'experiences' }  },
  { path: 'training', component: TrainingComponent, data: { state: 'training' }  },
  { path: 'training/:part', component: TrainingComponent, data: { state: 'training' }  },
  { path: 'book', component: BookComponent, data: { state: 'book' }  },
  { path: 'book/:part', component: BookComponent, data: { state: 'book' }  },
  { path: 'fleet', component: FleetComponent, data: { state: 'fleet' }  },
  { path: 'covid19', component: NewsComponent, data: { state: 'covid19' }  },
  { path: 'fleet/:part', component: FleetComponent, data: { state: 'fleet' }  },
  { path: 'membership', component: MembershipComponent, data: { state: 'membership' }  },
  { path: 'membership/join', component: JoinComponent, data: { state: 'join' } },
  { path: 'membership/renew', component: RenewComponent, data: { state: 'renew' } },
  { path: 'club', component: ClubComponent, data: { state: 'club' }  },
  { path: 'contact', component: ContactComponent, data: { state: 'contact' }  },
  { path: 'contact/:part', component: ContactComponent, data: { state: 'contact' }  },
  { path: 'fees', component: FeesComponent, data: { state: 'fees' }  },
  { path: 'tos', component: TosComponent, data: { state: 'tos' }  },
  { path: 'tnc', component: TncComponent, data: { state: 'tnc' }  },
  // { path: 'detail', loadChildren: './+detail#DetailModule'},
  // { path: 'barrel', loadChildren: './+barrel#BarrelModule'},
  { path: '**',    component: NoContentComponent },
];



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/app.routes.ts